import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import FocusBadge from 'components/badge/badgeFocus';
import UniversalBadge from 'components/badge/badgeUniversal';

export default (props) => {
	if (isFocusStudio()) return <FocusBadge {...props} />;
	return <UniversalBadge {...props} />;
};